export enum ENTITY_TYPE {
    PERSON = 'person',
    ORGANISATION = 'organisation',
}

type EntityParent = {
    name: string;
    id: string;
};

export type Entity = {
    id: string;
    created_at: string;
    modified_at: string;
    type: ENTITY_TYPE;
    name: string;
    phone?: string;
    email?: string;
    description?: string;
    identifier?: string;
    parent: EntityParent | null;
};
